import Swal from "sweetalert2";
import api from "../../../utilidades/interceptor";
import { formatearFecha } from "../../../utilidades/formateos";
const apiUrl = process.env.REACT_APP_API_KEY_ADMIN
export const getProveedores = async (setProveedores) => {
    await api.get(`${apiUrl}/admin/getAllProveedores`)
        .then((res) => {
            setProveedores(res.data)
            console.log("res", res.data);

        })
        .catch((error) => {
            console.log("error", error);
        })
}
export const getClientes = async (setClieintes) => {
    await api.get(`${apiUrl}/admin/getAllClients`)
        .then((res) => {
            setClieintes(res.data)
            console.log("res", res.data);

        })
        .catch((error) => {
            console.log("error", error);
        })
}
export const getRutas = async (id_cliente, setRuta) => {
    await api.get(`${apiUrl}/admin/getRutesByIdClient?id_cliente=${id_cliente}`)
        .then((res) => {
            setRuta(res.data)

        })
        .catch((error) => {
            console.log("error", error);
        })
}
export const getEstructura = async (id_ruta, setEstructura) => {

    await api.get(`${apiUrl}/admin/getEstrucuraByIdRoute?id_ruta=${id_ruta}`)
        .then((res) => {
            setEstructura(res.data)


        })
        .catch((error) => {
            console.log("error", error);
        })
}
export const getOperadores = async (setOperadores) => {

    await api.get(`${apiUrl}/admin/getOperadoresDisponibles`)
        .then((res) => {
            setOperadores(res.data)

        })
        .catch((error) => {
            console.log("error", error);
        })
}

export const getBitacoras = async (data, setBitacoras) => {
    Swal.fire({
        title: 'Cargando...',
        text: 'Obteniendo datos...',
        allowOutsideClick: false,  // Evita que el modal se cierre haciendo clic fuera
        allowEscapeKey: false,     // Evita que el modal se cierre con la tecla ESC
        didOpen: () => {
            Swal.showLoading();     // Muestra el spinner de carga
        }
    });
    const dataSend = {
        fecha_inicio:formatearFecha(data.desde),
        fecha_fin:formatearFecha(data.hasta),
        proveedor:data.proveedor?.code,
        cliente:data.cliente?.code,
        ruta:data.ruta?.code?data.ruta?.code:null,
        estructura:data.estructura?.code?data.estructura?.code:null,
        operador:data.operador?.code?data.operador?.code:null,
        unidad:data.unidad?data.unidad:null,
        id_bitacora:data.id?data.id:null
    }
    await api.post(`${apiUrl}/admin/get-bitacoras`,dataSend)
        .then((res) => {
            setBitacoras(res.data)
            Swal.close();

        })
        .catch((error) => {
            console.log("error", error);
        })
}

export const updateBitacora = async (data,showModal) => {
    await api.patch(`${apiUrl}/admin/bitacora/updateBitacora`,data)
    .then((res)=>{
        showModal(null)
    })
    .catch((error)=>{
        console.log("error",error);
        
    })
}

export const pagarServicio = async(id_bitacora) => {
    await api.patch(`${apiUrl}/admin/bitacora/pagar-servicio?id_bitacora=${id_bitacora}`)
    .then((res)=>{
        console.log("bitácora pagada");
        
    })
    .catch((error)=>{
        console.log("error",error);
        
    })
}
